<template>
  <ul>
    <li class="clearfix" v-for="(i, index) in linkInfo.nodeAttaches">
      <div class="num fl">{{ index + 1 }}</div>
      <i class="fl big-icon" :class="mapFileIcon(i.attachType)"></i>
      <div class="fl">
        <h1>
          {{
            i.attachName ||
            i.attachUrl.substring(
              i.attachUrl.lastIndexOf("\/") + 1,
              i.attachUrl.length
            )
          }}
        </h1>
        <h2>{{ i.attachSize }}kb</h2>
      </div>
      <el-button
        v-if="isShowDelete && isAdmin"
        type="text"
        class="delete fr"
        @click="delLink(i)"
        >删除</el-button
      >
      <el-button
        type="text"
        class="dow fr"
        @click="
          downloadFile(
            i.attachUrl,
            i.attachName ||
              i.attachUrl.substring(
                i.attachUrl.lastIndexOf('\/') + 1,
                i.attachUrl.length
              )
          )
        "
        >下载</el-button
      >
      <el-button type="text" class="look fr" @click="lookFile(i.attachUrl)"
        >查看</el-button
      >
    </li>
    <popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>
  </ul>
</template>
<script>
import { mapFileIcon, lookFile, downloadUrlFile } from "@/utils/index.js";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
import PopupDel from "@/components/PopupDel.vue";
export default {
  props: {
    linkInfo: {
      type: Object,
    },
    getLinkInfo: {
      type: Function,
    },
    isShowDelete: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PopupDel,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      delVisible: false,
      cur: null,
    };
  },
  created() {
    //this.init();
    // if (this.isShowDelete) {
    //   this.linkInfo.attaches = this.linkInfo.nodeAttaches;
    // }
  },
  methods: {
    mapFileIcon,
    lookFile,
    downloadFile(url, name) {
      //确认下载完成 后 进行下载记录保存
      downloadUrlFile(url, name);

      //保存下载记录
      let moduleType;
      if (this.$route.query.moduleType === "eduResearch") {
        moduleType = "research";
      } else if (this.$route.query.moduleType === "train") {
        moduleType = "training";
      } else if (this.$route.query.moduleType === "topicResearch") {
        moduleType = "topic";
      }
      postJson("/operator/saveDownloadInfo", {
        infoCode: this.linkInfo.nodeCode,
        module: moduleType,
        operatorId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode,
      });
    },
    delLink(info) {
      this.cur = info;
      this.delVisible = true;
    },
    // 删除弹框 关闭
    async closePopupDel(status) {
      try {
        if (status) {
          await postJson("/node/deleteNodeAttachInfo", {
            id: this.cur.id,
            operatorId: this.userInfo.userId,
          });
          this.$message({
            message: "删除成功",
            type: "success",
            duration: 2000,
            offset: 150,
          });
          this.delVisible = false;
          this.getLinkInfo(this.$route.query.nodeCode);
        } else {
          this.delVisible = false;
        }
      } catch (err) {
        console.log("err", err);
      }
      this.delVisible = false;
    },
  },
  watch: {},
};
</script>
<style lang="less" scoped>
ul {
  padding: 8px;
  li {
    padding: 8px;
    margin-bottom: 15px;
    background: #eee;
    border-radius: 5px;
    .big-icon {
      font-size: 35px;
      color: @color;
      // font-weight: 700;
    }
    .num {
      width: 35px;
      text-align: left;
      margin-top: 3px;
      font-size: 23px;
      margin-right: 20px;
      margin-left: 12px;
    }
    i {
      margin-top: 2px;
      font-size: 34px;
      margin-right: 10px;
    }
    img {
      margin-top: 5px;
      width: 50px;
      height: 30px;
      margin-right: 10px;
    }
    h1 {
      font-size: 15px;
      font-weight: 700;
    }
    h2 {
      font-size: 13px;
      color: @hui;
    }
    .look {
      margin-right: 100px;
    }
    .dow {
      margin-right: 100px;
    }
    .delete {
      margin-right: 100px;
      color: red;
    }
  }
}
</style>
